import { useRef, ReactNode, RefObject } from 'react';

type RefWrapperProps<T extends HTMLElement> = {
    children: (ref: RefObject<T>) => ReactNode;
};

export function RefWrapper<T extends HTMLElement>({ children }: RefWrapperProps<T>) {
    const ref = useRef<T>(null);
    return <>{children(ref)}</>;
}
